import { TradingEntity } from 'api'

export const isOperatingCountryReadOnly = (readOnly: boolean, tradingEntity: TradingEntity) => {
  const isCentralBank = tradingEntity.centralBank
  return readOnly || !isCentralBank
}
